<script>
    import { SweetModal } from 'sweet-modal-vue';
    export default {
        extends: SweetModal,
        methods: {
            //Overwrite base component _changeTab method.
			_changeTab(tab) {
				this.tabs.map(t => t.active = t == tab)
                this.currentTab = tab
                VueEvent.fire('tabChanged',tab);
			},
        }
    }
</script>
